module.exports = __webpack_public_path__ + "fonts/opensans-regular.ed6b9068.woff2";